import {Container} from '@material-ui/core'
import Styled from '../../components/Styled'
import styles from './styles'

export const Root = Styled(Container, styles.root)
